import { Toast } from "components/ToastShow/ToastAlert";
import { maximumTimeOut, REPORT_URL } from "utils/constants";
import { ENDPOINTSREPORT } from "utils/endpoints";
import { http } from "utils/http";

export const getReports = (scope) => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Report.tree,
    method: 'get',
     params: {
        scope: scope
     }
}).then((response) => (response.data))

export const deleteReport = (id) => http({
   baseURL:REPORT_URL ,
   url:ENDPOINTSREPORT.Report.report,
   method: 'delete',
    params: {
       id: id
    }
}).then((response) => (response.data))

export const exportReport = (id) => http({
   baseURL:REPORT_URL ,
   url:ENDPOINTSREPORT.Report.Export,
   method: 'get',
    responseType: "blob",
    params: {
       id: id
    }
   }).then((res) => {
      return res
  }).catch((err) => {
      
      return Promise.reject(err);
  });
  

export const importReportFiles = (fileData) => http({
   baseURL:REPORT_URL ,
   url:ENDPOINTSREPORT.Report.Import,
    method: 'post',
    data: fileData,
    params:{Confirm:false},

    headers: {
        "content-type": "multipart/form-data",
        Accept: "*/*",

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    
    return Promise.reject(err);
});


export const createMenu = (isTemplate ) => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Report.createMenu,
    method: 'post',
    params:{
        isTemplate 
    }
    }).then((res) => {
       return res
   }).catch((err) => {
       
       return Promise.reject(err);
   });
   export const syncReports = () => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Report.sync,
    timeout:maximumTimeOut,
    method: 'post',
    }).then((res) => {
       return res
   }).catch((err) => {
       
       return Promise.reject(err);
   });